import { Component, OnInit } from '@angular/core';
import { GlobalesService } from 'src/app/servicios/globales.service';

@Component({
  selector: 'app-pregunta-observaciones-actas',
  templateUrl: './pregunta-observaciones-actas.component.html',
  styleUrls: ['./pregunta-observaciones-actas.component.scss']
})
export class PreguntaObservacionesActasComponent implements OnInit {

  Search = "";

  constructor(public _globalService: GlobalesService) { }

  ngOnInit(): void {
    this._globalService.searchItem.subscribe(data =>{
      if(data == null) return;
      this.Search = data
    });
  }

}
